import { useT } from '@/i18n';
import { ChevronDown } from '@/components/ui';
import { RichText } from '@/components/trust/RichText';
import type { FaqId } from '@/content/faq';

/** Questions as native disclosures: keyboard- and screen-reader-friendly with no script. */
export const FaqList = ({ ids }: { ids: readonly FaqId[] }) => {
  const t = useT();
  return (
    <div className="divide-y divide-line border-y border-line">
      {ids.map((id) => (
        <details key={id} id={`faq-${id}`} className="group scroll-mt-24 py-2">
          <summary className="flex min-h-tap w-full cursor-pointer list-none items-center justify-between gap-4 py-1 text-label text-ink [&::-webkit-details-marker]:hidden">
            <span>{t(`faq.${id}.q`)}</span>
            <ChevronDown className="h-5 w-5 shrink-0 text-lagoon-600 transition-transform duration-fade group-open:rotate-180" />
          </summary>
          <p className="max-w-prose pb-4 pt-1 text-body leading-relaxed text-ink-soft">
            <RichText text={t(`faq.${id}.a`)} />
          </p>
        </details>
      ))}
    </div>
  );
};
